import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';
import { DigisubservicesService } from '../services/digisubservices.service';

interface DistrictRow {
  district_name: string;
  issue_copies: number;
  total_amount: number;
  entry_amount: number;
  remaining_amount: number;
}

interface PrantGroup {
  prant_id: number;
  prant_name: string;
  districts: DistrictRow[];
  total: {
    issue_copies: number;
    total_amount: number;
    entry_amount: number;
    remaining_amount: number;
  };
}

@Component({
  selector: 'app-issue-seller-districtwise-subscription-report',
  templateUrl: './issue-seller-districtwise-subscription-report.component.html',
  styleUrl: './issue-seller-districtwise-subscription-report.component.scss'
})
export class IssueSellerDistrictwiseSubscriptionReportComponent implements OnInit {
  // ---- Filter / request params (passed via dialog data) ----
  start_date = '';
  end_date = '';
  issue_date = '';
  issueName='';

  // ---- Header info ----
  today: Date;
  today1: string;
  endDate: any;

  // ---- Report data ----
  prants: PrantGroup[] = [];
  grandTotal = {
    issue_copies: 0,
    total_amount: 0,
    entry_amount: 0,
    remaining_amount: 0
  };

  isLoading = false;
  errorMessage = '';

  constructor(
    private dialogref: MatDialogRef<IssueSellerDistrictwiseSubscriptionReportComponent>,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService
  ) { }

  ngOnInit(): void {
    this.start_date = this.data['startDate'];
    this.end_date = this.data['endDate'];
   this.issue_date = this.data['issue_date'] ?? '';
    this.issueName = this.data['category'] ?? ''; 
    this.endDate = this.data['issuedate'] ?? this.end_date;

    this.today = new Date();
    this.today1 = this.datePipe.transform(this.today, 'dd-MM-yyyy');

    this.getReportData();
  }

  private parseNum(v: any): number {
    if (v == null) return 0;
    if (typeof v === 'number') return v;
    let s = String(v).replace(/[,₹\s%]/g, '').replace(/[^\d.-]/g, '');
    return s === '' ? 0 : (parseFloat(s) || 0);
  }

  getReportData() {
    this.isLoading = true;
    this.errorMessage = '';

    const req: any = {
      
      issuedate: this.issue_date,
     category:this.issueName,
    };

    this.service.getPrantDistrictwiseReport(req).subscribe({
      next: (res: any) => {
        const rawPrants: any[] = res?.prants ?? [];

        // Normalize numbers defensively, same as the granth report does with parseNum
        this.prants = rawPrants.map((p: any) => ({
          prant_id: p.prant_id,
          prant_name: p.prant_name,
          districts: (p.districts || []).map((d: any) => ({
            district_name: d.district_name,
            issue_copies: this.parseNum(d.issue_copies),
            total_amount: this.parseNum(d.total_amount),
            entry_amount: this.parseNum(d.entry_amount),
            remaining_amount: this.parseNum(d.remaining_amount)
          })),
          total: {
            issue_copies: this.parseNum(p.total?.issue_copies),
            total_amount: this.parseNum(p.total?.total_amount),
            entry_amount: this.parseNum(p.total?.entry_amount),
            remaining_amount: this.parseNum(p.total?.remaining_amount)
          }
        }));

        const gt = res?.grand_total ?? {};
        this.grandTotal = {
          issue_copies: this.parseNum(gt.issue_copies),
          total_amount: this.parseNum(gt.total_amount),
          entry_amount: this.parseNum(gt.entry_amount),
          remaining_amount: this.parseNum(gt.remaining_amount)
        };

        this.isLoading = false;
      },
      error: (err: any) => {
        console.error('Failed to load prant districtwise report', err);
        this.errorMessage = 'अहवाल लोड करताना त्रुटी आली.';
        this.isLoading = false;
      }
    });
  }

  exportexcel(fileName: string): void {
    const mainTable = document.getElementById('print-section');

    if (!mainTable) {
      console.error('Main table not found!');
      return;
    }

    try {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.table_to_sheet(mainTable);
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      XLSX.writeFile(wb, `${fileName}.xlsx`);
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  printPageA4Portrait() {
    const printContents = document.getElementById('print-section')?.innerHTML || '';
    const printWindow = window.open('', '_blank', 'width=794,height=1123');

    if (printWindow) {
      printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Print Report</title>
        <style>
          @page {
            size: A4 portrait;
            margin: 10mm 8mm 10mm 8mm;
          }

          @media print {
            body {
              font-family: Arial, sans-serif;
              font-size: 13px;
              line-height: 1.2;
              margin: 0;
              padding: 0;
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }

            table {
              border-collapse: collapse;
              width: 100%;
              page-break-inside: avoid;
            }

            th, td {
              border: 1px solid #000 !important;
              padding: 4px 6px !important;
              font-size: 13px !important;
              vertical-align: middle;
            }

            .noPrint, button, .btn {
              display: none !important;
            }

            th {
              font-weight: bold !important;
              text-align: center;
            }
          }

          @media screen {
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
            }

            table {
              border-collapse: collapse;
              margin: 20px auto;
            }

            th, td {
              border: 1px solid #000;
              padding: 8px;
            }
          }
        </style>
      </head>
      <body>
        <div id="print-section">
          ${printContents}
        </div>
      </body>
      </html>
    `);

      printWindow.document.close();

      printWindow.onload = function () {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        }, 500);
      };
    }
  }
}